import { useCallback } from 'react';
import { useTg } from './useTelegram';

export type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
export type NotificationStyle = 'error' | 'success' | 'warning';

export interface Haptic {
  impact: (style?: ImpactStyle) => void;
  notification: (style: NotificationStyle) => void;
  selectionChanged: () => void;
}

export function useHapticFeedback(): Haptic {
  const tg = useTg();
  const impact = useCallback(
    (style: ImpactStyle = 'light') => {
      tg?.HapticFeedback?.impactOccurred(style);
    },
    [tg],
  );
  const notification = useCallback(
    (style: NotificationStyle) => {
      tg?.HapticFeedback?.notificationOccurred(style);
    },
    [tg],
  );
  const selectionChanged = useCallback(() => {
    tg?.HapticFeedback?.selectionChanged();
  }, [tg]);
  return { impact, notification, selectionChanged };
}
